import { BaseSearchRequest } from '../utils';

export class AuditSearchRequest extends BaseSearchRequest {
  public auditDateMin?: string;
  public auditDateMax?: string;
}
